export default __webpack_public_path__ + "static/media/fashion_designer.68332925.jpg";